import { types, subTypes } from "./itemTypes";
import i18n from "../i18n";
import getSliderMark from "./Slider/getSliderMark";
import getChoiceOption from "./Choice/getChoiceOption";

// General stuff for a question
function generalQuestion(index) {
  return {
    id: index + "",
    type: types.unknown,
    label: "",
    title: "",
    conditions: [],
    defaultValue: undefined,
    items: [],
  };
}

// Make a new question
export default function getQuestion(type, index) {
  // MultipleChoice
  const multipleChoiceDefaultOption = [
    getChoiceOption({
      title: `${i18n.t("editor.placeholders.option")} 1`,
      number: 1,
    }),
  ];

  // Item defaults
  const itemTypes = {
    [subTypes.open]: {
      type: subTypes.open,
    },
    [subTypes.singleChoice]: {
      type: subTypes.singleChoice,
      showEnum: false,
      options: multipleChoiceDefaultOption,
      hasImages: false,
    },
    [subTypes.multipleChoice]: {
      type: subTypes.multipleChoice,
      showEnum: false,
      options: multipleChoiceDefaultOption,
      hasImages: false,
    },
    [subTypes.yesno]: {
      type: subTypes.yesno,
      options: [
        getChoiceOption({
          type: "no",
          title: i18n.t("editor.questionTypes.yesno.no"),
          number: 1,
        }),
        getChoiceOption({
          type: "yes",
          title: i18n.t("editor.questionTypes.yesno.yes"),
          number: 2,
        }),
      ],
    },
    [subTypes.computation]: {
      type: subTypes.computation,
      options: [
        getChoiceOption({
          type: "no",
          title: i18n.t("editor.questionTypes.yesno.no"),
          number: 1,
        }),
        getChoiceOption({
          type: "yes",
          title: i18n.t("editor.questionTypes.yesno.yes"),
          number: 2,
        }),
      ],
    },
    [subTypes.order]: {
      type: subTypes.order,
      options: multipleChoiceDefaultOption,
    },
    [subTypes.likert]: {
      type: subTypes.likert,
      options: [
        getChoiceOption({
          type: "not at all",
          title: i18n.t("editor.questionTypes.likert.not at all"),
          number: 1,
        }),
        getChoiceOption({
          type: "not",
          title: i18n.t("editor.questionTypes.likert.not"),
          number: 2,
        }),
        getChoiceOption({
          type: "a little",
          title: i18n.t("editor.questionTypes.likert.a little"),
          number: 3,
        }),
        getChoiceOption({
          type: "very",
          title: i18n.t("editor.questionTypes.likert.very"),
          number: 4,
        }),
        getChoiceOption({
          type: "extremely",
          title: i18n.t("editor.questionTypes.likert.extremely"),
          number: 5,
        }),
      ],
      showEnum: true,
    },
    [subTypes.multiSmiley]: {
      type: subTypes.multiSmiley,
      options: [
        getChoiceOption({
          type: "surprise",
          title: i18n.t("editor.questionTypes.smiley.surprise"),
          number: 1,
        }),
        getChoiceOption({
          type: "happy",
          title: i18n.t("editor.questionTypes.smiley.happy"),
          number: 2,
        }),
        getChoiceOption({
          type: "angry",
          title: i18n.t("editor.questionTypes.smiley.angry"),
          number: 3,
        }),
        getChoiceOption({
          type: "sad",
          title: i18n.t("editor.questionTypes.smiley.sad"),
          number: 4,
        }),
        getChoiceOption({
          type: "fear",
          title: i18n.t("editor.questionTypes.smiley.fear"),
          number: 5,
        }),
        getChoiceOption({
          type: "stress",
          title: i18n.t("editor.questionTypes.smiley.stress"),
          number: 6,
        }),
      ],
    },
    [subTypes.bodyParts]: {
      type: subTypes.bodyParts,
      options: [
        getChoiceOption({
          type: "head",
          title: i18n.t("editor.questionTypes.bodyParts.head"),
          number: 1,
        }),
        getChoiceOption({
          type: "neck",
          title: i18n.t("editor.questionTypes.bodyParts.neck"),
          number: 2,
        }),
        getChoiceOption({
          type: "belly",
          title: i18n.t("editor.questionTypes.bodyParts.belly"),
          number: 3,
        }),
        getChoiceOption({
          type: "neck and shoulders",
          title: i18n.t("editor.questionTypes.bodyParts.neck and shoulders"),
          number: 4,
        }),
        getChoiceOption({
          type: "left arm",
          title: i18n.t("editor.questionTypes.bodyParts.left arm"),
          number: 5,
        }),
        getChoiceOption({
          type: "left hand",
          title: i18n.t("editor.questionTypes.bodyParts.left hand"),
          number: 6,
        }),
        getChoiceOption({
          type: "right arm",
          title: i18n.t("editor.questionTypes.bodyParts.right arm"),
          number: 7,
        }),
        getChoiceOption({
          type: "right hand",
          title: i18n.t("editor.questionTypes.bodyParts.right hand"),
          number: 8,
        }),
        getChoiceOption({
          type: "left leg",
          title: i18n.t("editor.questionTypes.bodyParts.left leg"),
          number: 9,
        }),
        getChoiceOption({
          type: "left knee",
          title: i18n.t("editor.questionTypes.bodyParts.left knee"),
          number: 10,
        }),
        getChoiceOption({
          type: "left foot",
          title: i18n.t("editor.questionTypes.bodyParts.left foot"),
          number: 11,
        }),
        getChoiceOption({
          type: "right leg",
          title: i18n.t("editor.questionTypes.bodyParts.right leg"),
          number: 12,
        }),
        getChoiceOption({
          type: "right knee",
          title: i18n.t("editor.questionTypes.bodyParts.right knee"),
          number: 13,
        }),
        getChoiceOption({
          type: "right foot",
          title: i18n.t("editor.questionTypes.bodyParts.right foot"),
          number: 14,
        }),
      ],
    },
    [subTypes.slider]: {
      type: subTypes.slider,
      marks: [
        getSliderMark({
          type: "not at all",
          value: 0,
          label: i18n.t("editor.questionTypes.likert.not at all"),
        }),
        getSliderMark({
          type: "extremely",
          value: 100,
          label: i18n.t("editor.questionTypes.likert.extremely"),
        }),
      ],
    },
    [subTypes.sliderNeutralPos]: {
      type: subTypes.slider,
      marks: [
        getSliderMark({
          type: "neutral",
          value: 0,
          label: i18n.t("editor.questionTypes.slider.neutral"),
        }),
        getSliderMark({
          type: "extremely",
          value: 100,
          label: i18n.t("editor.questionTypes.likert.extremely"),
        }),
      ],
    },
    [subTypes.sliderNegPos]: {
      type: subTypes.slider,
      marks: [
        getSliderMark({
          type: "not at all",
          value: 0,
          label: i18n.t("editor.questionTypes.likert.not at all"),
        }),
        getSliderMark({
          type: "extremely",
          value: 100,
          label: i18n.t("editor.questionTypes.likert.extremely"),
        }),
      ],
    },
    [subTypes.smiley]: {
      type: subTypes.smiley,
      typeSmiley: "null",
      marks: [
        getSliderMark({ type: "", value: 0, label: "" }),
        getSliderMark({ type: "", value: 100, label: "" }),
      ],
    },
    [subTypes.container]: {
      type: subTypes.container,
    },
    [subTypes.text]: {
      type: subTypes.text,
    },
  };

  if (itemTypes?.[type]) {
    return { ...generalQuestion(index), ...itemTypes[type] };
  }
  return {
    ...generalQuestion(index),
    type: type,
  };
}
